import { useFlag } from '@calendly/feature-check-react'
import { HtmlParser } from '@calendly/html-parser'
import { I18n } from '@calendly/i18n'
import { Badge } from '@calendly/ui/components/badge'
import { Button } from '@calendly/ui/components/button'
import { AiSparkleIcon } from '@calendly/ui/components/icons'
import { PageHeader } from '@calendly/ui/components/page-header'
import { BodyText, HeadingText } from '@calendly/ui/components/typography'
import { useSelector } from 'react-redux'

import { isAvailableFeatureSelector } from 'features/billing'
import { AdminDisabledNotetakerBanner } from 'features/meeting_intelligence/components'
import { SampleRecapButton } from 'features/meeting_intelligence/components/sample_recap_button'
import { useNotetakerFreeMeetingsQuota } from 'features/meeting_intelligence/hooks'
import { LearnMoreLinkMeetingRecaps } from 'features/meeting_intelligence/utils'
import { useNotetakerFiveFreeRecapsExperiment } from 'hooks/useNotetakerFiveFreeRecapsExperiment'

import { ButtonContainer, LandingPageContainer, LandingImage, CopyWrapper, DeleteDisclaimerWrapper } from './styles'
import LandingPageImage from '../../assets/user-MI-illustration.png'
import { ModifiedPageContainer } from '../../user/styles'
import { DeleteFooter } from '../delete_footer'

export const EmptyState = ({
  setShowDeleteModal,
  handleTrackModal,
  wasPreviouslyEnabled,
  handleEmptyStateClick,
  adminDisabledNotetaker
}) => {
  const isMeetingIntelligenceAvailable = useSelector((state) => isAvailableFeatureSelector(state, { featureKey: 'meeting_intelligence' }))
  const hasMsTeamsFlag = useFlag('ms_teams_notetaker')
  const { isInExperiment: isInNotetakerFiveFreeRecapsExperiment } = useNotetakerFiveFreeRecapsExperiment()
  const { hasRemainingFreeMeetings } = useNotetakerFreeMeetingsQuota({
    skip: !isInNotetakerFiveFreeRecapsExperiment
  })

  const getButtonText = () => {
    if (wasPreviouslyEnabled && (isMeetingIntelligenceAvailable || hasRemainingFreeMeetings)) {
      return I18n.t('publisher.personal_settings.meeting_recaps.landing.prev_enabled_button_text')
    }

    if (hasRemainingFreeMeetings) return I18n.t('publisher.billing.meeting_intelligence.get_notetaker')

    if (isMeetingIntelligenceAvailable) return I18n.t('publisher.billing.meeting_intelligence.try_notetaker')

    return I18n.t('publisher.billing.meeting_intelligence.upgrade_plan')
  }

  return (

    <ModifiedPageContainer>
      <PageHeader
        badge={adminDisabledNotetaker ? <Badge type="error">{I18n.t('publisher.personal_settings.meeting_recaps.disabled')}</Badge> : null}
        eyebrow={[
          <BodyText weight="bold" color="muted">
            {I18n.t('publisher.personal_settings.navigation.account_details')}
          </BodyText>
        ]}
        title={I18n.t('publisher.personal_settings.meeting_recaps.meeting_recaps')}
      />
      <AdminDisabledNotetakerBanner adminDisabledNotetaker={adminDisabledNotetaker} />
      <LandingPageContainer>
        <CopyWrapper>
          <HeadingText size="medium">{I18n.t('publisher.personal_settings.meeting_recaps.landing.title')}</HeadingText>
          <BodyText>
            {HtmlParser(
              hasMsTeamsFlag
                ? I18n.t('publisher.personal_settings.meeting_recaps.landing.description_with_teams')
                : I18n.t('publisher.personal_settings.meeting_recaps.landing.description')
            )}
          </BodyText>
          <div>
            <BodyText>
              {HtmlParser(
                I18n.t('publisher.personal_settings.meeting_recaps.landing.learn_more'),
                { LearnMoreLinkMeetingRecaps }
              )}
            </BodyText>
          </div>
          <ButtonContainer>
            <Button decoration="meeting-intelligence" onClick={handleEmptyStateClick} disabled={adminDisabledNotetaker}>
              <AiSparkleIcon />
              {getButtonText()}
            </Button>
            <SampleRecapButton ctaKey="ai_notetaker_settings" />
          </ButtonContainer>
        </CopyWrapper>
        <LandingImage src={LandingPageImage} />
      </LandingPageContainer>
      {wasPreviouslyEnabled && (
      <DeleteDisclaimerWrapper>
        <DeleteFooter handleTrackModal={handleTrackModal} setShowDeleteModal={setShowDeleteModal} />
      </DeleteDisclaimerWrapper>
      )}
    </ModifiedPageContainer>
  )
}
